// Left navigation items
export const navItems = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Collections", href: "/collections" },
  { label: "Contact Us", href: "/contact" },
  { label: "Blog" , href:"/blog"}
];

// Right utilities
export const utilities = [
  { type: "icon", label: "Search", icon: "FiSearch" },
  { type: "icon", label: "Wishlist", icon: "FiHeart" },
  { type: "icon", label: "Cart", icon: "FiShoppingCart" },
  { type: "button", label: "Login", href: "/login" },
];

export const people = [
  {
    id: 1,
    name: "Arul Raj",
    designation: "Tanjore Art Enthusiast",
    image:
      "/assets/testimonials/img1.webp",
  },
  {
    id: 2,
    name: "Priya Selvan",
    designation: "Collector of Tanjore Paintings",
    image:
      "/assets/testimonials/img2.webp",
  },
  {
    id: 3,
    name: "Karthik Subramanian",
    designation: "Art Lover from Chennai",
    image:
      "/assets/testimonials/img3.webp",
  },
  {
    id: 4,
    name: "Anitha Ramachandran",
    designation: "Fan of Traditional Art",
    image:
      "/assets/testimonials/img4.webp",
  },
  {
    id: 5,
    name: "Vignesh Kumar",
    designation: "Patron of Indian Handicrafts",
    image:
      "/assets/testimonials/img5.webp",
  },
  {
    id: 6,
    name: "Divya Reddy",
    designation: "Lover of South Indian Art",
    image:
      "/assets/testimonials/img6.webp",
  },
];




export const CardProducts = [
  {
    id: 1,
    name: "Lord Balaji",
    slug: "lord-balaji",
    category: "Balaji",
    img: "/assets/webp/balaji mockup-2.webp",
    desc: "Traditional Tanjore painting of Lord Balaji.",
    
    variations: {
      sizes: [
        "36x24 inches",
        "48x36 inches",
        "15x12 inches",
        "18x14 inches",
        "20x16 inches",
        "24x18 inches",
        "30x24 inches",
        "60x36 inches",
        "72x48 inches",
        "15x60 inches"
      ],
      frameTypes: [
        "Flat",
        "2D",
        "3D Embossed"
      ],
      prices: {} // you will update later
    },

    tags: ["balaji", "tanjore"]
  },

  {
    id: 2,
    name: "Lord Krishna",
    slug: "lord-krishna",
    category: "Krishna",
    img: "/assets/webp/balaji mockup-2.webp",
    desc: "Vibrant Krishna Tanjore artwork.",
    
    variations: {
      sizes: [
        "36x24 inches",
        "48x36 inches",
        "15x12 inches",
        "18x14 inches",
        "20x16 inches",
        "24x18 inches",
        "30x24 inches",
        "60x36 inches",
        "72x48 inches",
        "15x60 inches"
      ],
      frameTypes: [
        "Flat",
        "2D",
        "3D Embossed"
      ],
      prices: {}
    },

    tags: ["krishna", "tanjore"]
  },

  {
    id: 3,
    name: "Lord Shiva",
    slug: "lord-shiva",
    category: "Shiva",
    img: "/assets/webp/Shiva-1.webp",
    desc: "Detailed Tanjore painting of Lord Shiva.",
    
    variations: {
      sizes: [
        "36x24 inches",
        "48x36 inches",
        "15x12 inches",
        "18x14 inches",
        "20x16 inches",
        "24x18 inches",
        "30x24 inches",
        "60x36 inches",
        "72x48 inches",
        "15x60 inches"
      ],
      frameTypes: [
        "Flat",
        "2D",
        "3D Embossed"
      ],
      prices: {}
    },

    tags: ["shiva", "tanjore"]
  },

  {
    id: 4,
    name: "Lord Murugan",
    slug: "lord-murugan",
    category: "Murugan",
    img: "/assets/webp/Murugan-1.webp",
    desc: "Classic Tanjore painting of Lord Murugan.",
    
    variations: {
      sizes: [
        "36x24 inches",
        "48x36 inches",
        "15x12 inches",
        "18x14 inches",
        "20x16 inches",
        "24x18 inches",
        "30x24 inches",
        "60x36 inches",
        "72x48 inches",
        "15x60 inches"
      ],
      frameTypes: [
        "Flat",
        "2D",
        "3D Embossed"
      ],
      prices: {}
    },

    tags: ["murugan", "tanjore"]
  },

  {
    id: 5,
    name: "Goddess Lakshmi",
    slug: "goddess-lakshmi",
    category: "Lakshmi",
    img: "/assets/webp/Lakshmi-with frame.webp",
    desc: "Traditional Tanjore painting of Goddess Lakshmi.",
    
    variations: {
      sizes: [
        "36x24 inches",
        "48x36 inches",
        "15x12 inches",
        "18x14 inches",
        "20x16 inches",
        "24x18 inches",
        "30x24 inches",
        "60x36 inches",
        "72x48 inches",
        "15x60 inches"
      ],
      frameTypes: [
        "Flat",
        "2D",
        "3D Embossed"
      ],
      prices: {}
    },

    tags: ["lakshmi", "tanjore"]
  },

  {
    id: 6,
    name: "Goddess Saraswathi",
    slug: "goddess-saraswathi",
    category: "Saraswathi",
    img: "/assets/webp/saraswati-flat.webp",
    desc: "Elegant Tanjore artwork of Goddess Saraswathi.",
    
    variations: {
      sizes: [
        "36x24 inches",
        "48x36 inches",
        "15x12 inches",
        "18x14 inches",
        "20x16 inches",
        "24x18 inches",
        "30x24 inches",
        "60x36 inches",
        "72x48 inches",
        "15x60 inches"
      ],
      frameTypes: [
        "Flat",
        "2D",
        "3D Embossed"
      ],
      prices: {}
    },

    tags: ["saraswathi", "tanjore"]
  }
];




